import { useEffect } from 'react';
import { useSingleton } from '@bydesign-ui/hooks';
import { Form } from '../../../models/form';
export function useCreateForm(props) {
  var form = props.form,
      onModelChange = props.onModelChange,
      onSubmit = props.onSubmit,
      onSubmitFailed = props.onSubmitFailed,
      onValuesChange = props.onValuesChange,
      defaultModel = props.defaultModel;
  var ins = useSingleton(function () {
    if (form != null) {
      return form;
    }

    return new Form({
      model: defaultModel
    });
  });
  useEffect(function () {
    ins.addListener('model-change', onModelChange);
    ins.addListener('values-change', onValuesChange);
    ins.addListener('submit', onSubmit);
    ins.addListener('submit-failed', onSubmitFailed);
    return function () {
      ins.removeListener('model-change', onModelChange);
      ins.removeListener('values-change', onValuesChange);
      ins.removeListener('submit', onSubmit);
      ins.removeListener('submit-failed', onSubmitFailed);
    };
  }, []);
  return ins;
}